<!-- <p>view-container works!</p> -->
<div [ngClass]="getClassForView()">
  <div class="data-not-ready" *ngIf="!isDataReady">
    <mat-spinner></mat-spinner>
  </div>
  <div class="data-not-ready error-banner" *ngIf="isDataReady && isNotValid">
    <i>Not a valid link! Please check the URL again</i>
  </div>
  <div
    class="data-not-ready warn-banner"
    *ngIf="isDataReady && isError && !isOrgError"
  >
    <i
      >Not a valid {{ linkType | titlecase }} Id, or this
      {{ linkType | titlecase }} has been removed, Please check the URL!</i
    >
  </div>
  <div
    class="data-not-ready error-banner"
    *ngIf="isDataReady && isError && isOrgError"
  >
    You are trying to open a {{ linkType | titlecase }} link in another org,
    Please Login to view!
  </div>
  <Section *ngIf="isShowIncidentSection && isDataReady && !isError">
    <div style="margin-bottom: 10px">
      <app-incident-detail
        [isOnlyView]="false"
        [selectedCommentId]="selectedCommentId"
        [incidentDetails]="incidentDetails"
        (closeIncidentDetail)="onCloseDetail()"
        (snoozeIncident)="onSnoozeIncident($event)"
        (showTimeline)="onShowTimeline($event)"
        (postIncidentComment)="onPostIncidentComment($event)"
        [orgUser]="dashboardData.orgUserList"
        [OrgAssets]="dashboardData.orgAssetList.assets"
      ></app-incident-detail>
    </div>

    <mat-divider></mat-divider>
    <div *ngIf="isShowIncidentTimline && (isFaceIncident || isANPRIncident)">
      <div class="incident-timeline-card">
        <mat-card>
          <mat-card-content class="incident-table-card-content">
            <app-face-timeline-table
              [incidentTableData]="incidentDetails"
            ></app-face-timeline-table>
          </mat-card-content>
        </mat-card>
      </div>
    </div>
  </Section>
  <Section *ngIf="isShowVisitorSection && isDataReady && !isError">
    <div style="margin-bottom: 10px">
      <app-visitor-detail
        [visitorDetails]="visitorDetails"
        [orgUser]="dashboardData.orgUserList"
        (closeVisitorDetail)="onCloseDetail()"
        (showVisitorTimeline)="onShowVisitorTimeline($event)"
        (updateVisitorDetails)="onUpdateVisitorDetails($event)"
        (postVisitorComment)="onPostVisitorComment($event)"
        [selectedCommentId]="selectedCommentId"
      ></app-visitor-detail>
    </div>

    <mat-divider></mat-divider>
    <div *ngIf="isShowVisitorTimline">
      <div class="incident-timeline-card">
        <mat-card style="height: calc(100% - 10px)">
          <mat-card-content class="visitor-table-card-content">
            <app-visitor-timeline
              [visitorTableData]="visitorDetails"
            ></app-visitor-timeline>
          </mat-card-content>
        </mat-card>
      </div>
    </div>
  </Section>
</div>
<br />
<br />
<br />
<br />
